module.exports = __webpack_public_path__ + "static/Jurg-Zeltner-bc369dfda13c4888020cb2c405849354.webp";